(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allpowers-product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const selector = '[data-apcmp-section]';
  const init = root => {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-apcmp-track]');
    const slides = Array.from(root.querySelectorAll('[data-apcmp-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-apcmp-dot]'));
    const next = root.querySelector('[data-apcmp-next]');
    if (!track || slides.length < 2) return;
    const listeners = [];
    let active = 0;
    let frame = 0;
    let resizeFrame = 0;
    const listen = (target, type, callback, options) => {
      if (!target) return;
      target.addEventListener(type, callback, options);
      listeners.push(() => target.removeEventListener(type, callback, options));
    };
    const setActive = index => {
      active = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
    };
    const goTo = (index, animate = true) => {
      const safeIndex = (index + slides.length) % slides.length;
      const offset = slides[safeIndex].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({
        left: offset,
        behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
      });
      setActive(safeIndex);
    };
    listen(track, 'scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const currentDistance = Math.abs(center - (slide.offsetLeft + slide.offsetWidth / 2));
          if (currentDistance < distance) { distance = currentDistance; nearest = i; }
        });
        setActive(nearest);
      });
    }, { passive: true });
    dots.forEach((dot, i) => listen(dot, 'click', () => goTo(i)));
    listen(next, 'click', () => goTo(active + 1));
    listen(track, 'keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(active + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(active - 1); }
    });
    listen(window, 'resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => {
        if (track.clientWidth > 0) goTo(active, false);
      });
    }, { passive: true });
    setActive(0);
    instances.set(root, () => {
      listeners.forEach(remove => remove());
      window.cancelAnimationFrame(frame);
      window.cancelAnimationFrame(resizeFrame);
    });
  };
  const rootsIn = scope => scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll(selector));
  const mount = scope => rootsIn(scope).forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else { mount(document); }
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => rootsIn(event.target).forEach(root => {
    instances.get(root)?.();
    instances.delete(root);
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allpowers-product-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-apcps-universal]';
  const cleanups = new WeakMap();
  const initPaging = (section) => {
if (!section || section.dataset.productPagingReady === 'true') return;
    section.dataset.productPagingReady = 'true';

    const track = section.querySelector('[data-apcps-track]');
    const cards = track ? Array.from(track.querySelectorAll('[data-apcps-card]')) : [];
    const viewport = section.querySelector('[data-apcps-viewport]');
    const controls = section.querySelector('[data-apcps-controls]');
    const previousButton = section.querySelector('[data-apcps-prev]');
    const nextButton = section.querySelector('[data-apcps-next]');
    const progressButton = section.querySelector('[data-apcps-progress]');
    const progressFill = section.querySelector('[data-apcps-progress-fill]');
    const pageCounter = section.querySelector('[data-apcps-counter]');
    const mobileToggle = section.querySelector('[data-apcps-mobile-toggle]');
    const toggleLabel = section.querySelector('[data-apcps-toggle-label]');
    const toggleIcon = section.querySelector('[data-apcps-toggle-icon]');
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pageSize = 4;
    let currentPage = 0;
    let expanded = false;
    let pageStarts = [];
    let resizeTimer;
    let dragging = false;
    let dragStartX = 0;
    let dragDeltaX = 0;
    let dragStartOffset = 0;
    let suppressClick = false;
    const interactiveSelector = 'a, button, input, select, textarea, label, klarna-placement, [role="button"]';

    if (!track || !cards.length) return;

    const buildPageStarts = () => {
      const pageCount = Math.ceil(cards.length / pageSize);
      const lastFullStart = Math.max(0, cards.length - pageSize);

      return Array.from({ length: pageCount }, (_, pageIndex) => {
        return Math.min(pageIndex * pageSize, lastFullStart);
      });
    };

    const updateDesktopPosition = (animate = true) => {
      if (mobileMedia.matches) {
        track.style.transform = 'none';
        if (controls) controls.hidden = true;
        if (viewport) viewport.dataset.draggable = 'false';
        return;
      }

      pageStarts = buildPageStarts();
      currentPage = Math.min(currentPage, Math.max(0, pageStarts.length - 1));
      const startIndex = pageStarts[currentPage] || 0;
      const targetCard = cards[startIndex];
      const offset = targetCard ? targetCard.offsetLeft : 0;

      track.style.transition = animate && !reducedMotion.matches ? '' : 'none';
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      if (!animate || reducedMotion.matches) {
        requestAnimationFrame(() => { track.style.transition = ''; });
      }

      updateControls();
    };

    const updateControls = () => {
      pageStarts = buildPageStarts();
      const totalPages = Math.max(1, pageStarts.length);
      const visible = !mobileMedia.matches && totalPages > 1;
      if (controls) controls.hidden = !visible;
      if (viewport) viewport.dataset.draggable = String(visible);
      if (previousButton) previousButton.disabled = currentPage <= 0;
      if (nextButton) nextButton.disabled = currentPage >= totalPages - 1;
      if (pageCounter) pageCounter.textContent = `${currentPage + 1} / ${totalPages}`;
      if (progressFill) progressFill.style.transform = `scaleX(${(currentPage + 1) / totalPages})`;
      if (progressButton) {
        progressButton.setAttribute('aria-valuemax', String(totalPages));
        progressButton.setAttribute('aria-valuenow', String(currentPage + 1));
        progressButton.setAttribute('aria-valuetext', `Page ${currentPage + 1} of ${totalPages}`);
      }
    };

    const updateMobileCards = (scrollAfterCollapse = false) => {
      if (!mobileToggle) return;

      if (!mobileMedia.matches) {
        cards.forEach((card) => { card.hidden = false; });
        mobileToggle.hidden = true;
        return;
      }

      const hasMore = cards.length > pageSize;
      mobileToggle.hidden = !hasMore;

      cards.forEach((card, index) => {
        card.hidden = !expanded && index >= pageSize;
      });

      mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (toggleLabel) {
        toggleLabel.textContent = expanded
          ? mobileToggle.dataset.lessText
          : mobileToggle.dataset.moreText;
      }
      if (toggleIcon) toggleIcon.textContent = expanded ? '−' : '＋';

      if (scrollAfterCollapse) {
        section.querySelector('[data-apcps-product-area]')?.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    };

    const goToPage = (page) => {
      pageStarts = buildPageStarts();
      currentPage = Math.max(0, Math.min(page, pageStarts.length - 1));
      updateDesktopPosition(true);
      section.dispatchEvent(new Event('apcps:layout'));
    };

    previousButton?.addEventListener('click', () => goToPage(currentPage - 1));
    nextButton?.addEventListener('click', () => goToPage(currentPage + 1));

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (suppressClick || event.defaultPrevented || event.target.closest(interactiveSelector)) return;
        const productUrl = card.dataset.productUrl;
        if (productUrl) window.location.assign(productUrl);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target !== card) return;
        const productUrl = card.dataset.productUrl;
        if (!productUrl) return;
        event.preventDefault();
        window.location.assign(productUrl);
      });
    });

    progressButton?.addEventListener('click', (event) => {
      if (!event.detail || mobileMedia.matches || pageStarts.length <= 1) return;
      const rect = progressButton.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / Math.max(1, rect.width)));
      goToPage(Math.round(ratio * (pageStarts.length - 1)));
    });

    progressButton?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPage(currentPage - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToPage(currentPage + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        goToPage(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        goToPage(pageStarts.length - 1);
      }
    });

    viewport?.addEventListener('pointerdown', (event) => {
      if (mobileMedia.matches || pageStarts.length <= 1 || event.button !== 0) return;
      if (event.target.closest(interactiveSelector)) return;
      const startCard = cards[pageStarts[currentPage] || 0];
      dragging = true;
      dragStartX = event.clientX;
      dragDeltaX = 0;
      dragStartOffset = startCard ? startCard.offsetLeft : 0;
      track.style.transition = 'none';
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport?.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      dragDeltaX = event.clientX - dragStartX;
      track.style.transform = `translate3d(${-(dragStartOffset - dragDeltaX)}px, 0, 0)`;
      if (Math.abs(dragDeltaX) > 6) event.preventDefault();
    });

    const finishDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      viewport?.classList.remove('is-dragging');
      if (viewport?.hasPointerCapture?.(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      const threshold = Math.min(90, Math.max(44, (viewport?.clientWidth || 0) * .08));
      if (dragDeltaX <= -threshold) currentPage += 1;
      if (dragDeltaX >= threshold) currentPage -= 1;
      if (Math.abs(dragDeltaX) > 6) {
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 0);
      }
      goToPage(currentPage);
    };

    viewport?.addEventListener('pointerup', finishDrag);
    viewport?.addEventListener('pointercancel', finishDrag);
    viewport?.addEventListener('dragstart', (event) => event.preventDefault());
    viewport?.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    mobileToggle?.addEventListener('click', () => {
      const wasExpanded = expanded;
      expanded = !expanded;
      updateMobileCards(wasExpanded && !expanded);
      section.dispatchEvent(new Event('apcps:layout'));
    });

    const refreshLayout = (animate = false) => {
      updateMobileCards(false);
      updateDesktopPosition(animate);
    };

    const handleViewportChange = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => refreshLayout(false), 80);
    };

    window.addEventListener('resize', handleViewportChange, { passive: true });
    mobileMedia.addEventListener?.('change', handleViewportChange);
    refreshLayout(false);
    return () => {
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', handleViewportChange);
      mobileMedia.removeEventListener?.('change', handleViewportChange);
    };
  };
  const initKlarna = (section) => {

    if (section.dataset.klarnaReady === 'true') return;
    const placements = Array.from(section.querySelectorAll('[data-apcps-klarna-wrap] klarna-placement'));
    if (!placements.length) return;
    section.dataset.klarnaReady = 'true';
    const note = section.querySelector('[data-apcps-klarna-status]');
    const timers = [];
    const refresh = () => {
      if (!section.isConnected) return;
      try {
        if (window.Klarna?.OnsiteMessaging?.refresh) {
          window.Klarna.OnsiteMessaging.refresh();
        } else {
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
      } catch (error) {
        console.warn('ALLPOWERS showcase: Klarna refresh failed.', error);
      }
    };
    const schedule = () => {
      timers.splice(0).forEach(window.clearTimeout);
      [0, 300, 900, 1800, 3500].forEach(delay => timers.push(window.setTimeout(refresh, delay)));
    };
    const findSdk = () => document.querySelector(
      'script[src*="js.klarna.com/web-sdk"], script[src*="klarnaservices.com/lib.js"]'
    );
    const alreadyAvailable = () => Boolean(window.Klarna?.OnsiteMessaging || window.customElements?.get('klarna-placement'));
    const attachSdk = (script) => {
      script.addEventListener('load', schedule, { once: true });
      schedule();
    };
    section.addEventListener('apcps:layout', schedule);
    const existing = findSdk();
    if (existing) {
      attachSdk(existing);
    } else if (alreadyAvailable()) {
      schedule();
    } else {
      // Share one in-flight loader across this module's instances.
      // Do not replace another theme/app's SDK, configuration or callback.
      window.__apcpsKlarnaSdkPromise = window.__apcpsKlarnaSdkPromise || (async () => {
        let clientId = section.dataset.klarnaClientId?.trim() || '';
        let environment = 'production';
        if (!clientId) {
          const defaultDomain = section.dataset.shopDomain || window.Shopify?.shop || '';
          if (!defaultDomain) throw new Error('Current Shopify shop domain is missing.');
          const storeUrl = new URL('/app-blocks/v1/store', 'https://skosm.klarna.com');
          storeUrl.searchParams.set('defaultDomain', defaultDomain);
          storeUrl.searchParams.set('customDomain', window.location.hostname !== defaultDomain ? window.location.hostname : '');
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 10000);
          try {
            const response = await fetch(storeUrl.toString(), { signal: controller.signal });
            if (!response.ok) throw new Error('Klarna store configuration unavailable.');
            const store = await response.json();
            clientId = typeof store.client_id === 'string' ? store.client_id.trim() : '';
            environment = store.playground_active ? 'playground' : 'production';
          } finally {
            window.clearTimeout(timeout);
          }
        }
        // The installed UK app might have loaded while configuration was fetched.
        const lateSdk = findSdk();
        if (lateSdk) { attachSdk(lateSdk); return; }
        if (alreadyAvailable()) return;
        if (!clientId) throw new Error('UK Klarna public client ID is missing.');
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.id = 'apcps-klarna-sdk';
          script.async = true;
          script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
          script.setAttribute('data-environment', environment);
          script.setAttribute('data-client-id', clientId);
          const timeout = window.setTimeout(() => reject(new Error('Klarna SDK timed out.')), 15000);
          script.addEventListener('load', () => { window.clearTimeout(timeout); resolve(); }, { once: true });
          script.addEventListener('error', () => { window.clearTimeout(timeout); reject(new Error('Klarna SDK could not load.')); }, { once: true });
          document.head.appendChild(script);
        });
      })().catch(error => {
        window.__apcpsKlarnaSdkPromise = null;
        throw error;
      });
      window.__apcpsKlarnaSdkPromise.then(schedule).catch((error) => {
        // A finance widget failure must never block navigation or add-to-cart.
        if (!section.isConnected) return;
        console.warn('ALLPOWERS showcase: UK Klarna could not initialise.', error);
        if (note) {
          note.textContent = 'Klarna 未加载：请检查英国店铺的 On-site messaging、域名授权和 GBP 设置。独立接入时可填写本模块的英国公共 Client ID；不要使用 API 密钥。此提示仅后台可见。';
          note.hidden = false;
        }
      });
    }
    return () => {
      timers.forEach(window.clearTimeout);
      section.removeEventListener('apcps:layout', schedule);
    };

  };
  const initCart = (section) => {
if (!section || section.dataset.cartReady === 'true') return;
      section.dataset.cartReady = 'true';

      section.addEventListener('click', async (event) => {
        const button = event.target.closest('.js-apcps-add');
        if (!button || button.disabled) return;

        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;

        const originalText = button.textContent.trim();
        button.disabled = true;
        button.textContent = section.dataset.addingText || 'Adding…';

        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed');
          button.textContent = section.dataset.addedText || 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          button.textContent = section.dataset.errorText || 'Please try again';
        }

        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1600);
      });
  };
  const init = (scope = document) => {
    const sections = scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll(selector));
    sections.forEach(section => {
      if (cleanups.has(section)) return;
      const cleanup = [];
      [initPaging, initKlarna, initCart].forEach(initialise => {
        try {
          const dispose = initialise(section);
          if (typeof dispose === 'function') cleanup.push(dispose);
        } catch (error) { console.warn('ALLPOWERS showcase could not initialise a feature.', error); }
      });
      cleanups.set(section, () => cleanup.forEach(dispose => dispose()));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else { init(); }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(section => {
      cleanups.get(section)?.();
      cleanups.delete(section);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
